import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-use-policy",
  templateUrl: "./use-policy.component.html",
  styleUrls: ["./use-policy.component.scss"],
})
export class UsePolicyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
